import { GrocyProductBasics } from '../../../../core/entities/grocy/products/product-basics.entity';
import { FormOptions } from '../../../../forms/form-options/base.form-options';

export class GrocyDashboardProductFormOptions extends FormOptions {
  grocyProducts: GrocyProductBasics[] = [];
}
